// Gesture support (required by material2)

import { BrowserModule } from '@angular/platform-browser';
import { NgModule, inject } from '@angular/core';

// UI modules
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

// Feature modules
import { CoreModule } from '../modules/core/core.module';

import { AppComponent } from './app.component';
import { MenuComponent } from 'src/modules/core/components/menu/menu.component';
import { SettingsMenuComponent } from 'src/modules/core/components/settings-menu/settings-menu.component';


@NgModule({
   declarations: [
      AppComponent
   ],
   imports: [
      BrowserModule,

      // Material2
      MatButtonModule,
      MatCardModule,
      MatCheckboxModule,
      MatDatepickerModule,
      MatDialogModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatListModule,
      MatMenuModule,
      MatOptionModule,
      MatProgressBarModule,
      MatProgressSpinnerModule,
      MatRadioModule,
      MatSelectModule,
      MatSidenavModule,
      MatSlideToggleModule,
      MatTabsModule,
      MatTableModule,
      MatToolbarModule,
      MatTooltipModule,

      // Features
      CoreModule,

      MenuComponent,
      SettingsMenuComponent
   ],
   bootstrap: [AppComponent]
})
export class AppModule {

   constructor() {
      const iconRegistry = inject(MatIconRegistry);

      iconRegistry.setDefaultFontSetClass('material-symbols-rounded');
   }
}
